import React, { useRef } from 'react';
import { Compass } from 'lucide-react';
import { MoreHorizontal } from 'lucide-react';
import { Trash } from 'lucide-react';
import { Flag } from 'lucide-react';
import { DropdownMenu, DropdownMenuItem, cn } from '@edusense/shared-ui-kit';
import { CategoryBadge } from '@edusense/entities-project';
import { ContentMediaGrid } from '@edusense/entities-media';
import { ProjectStats } from '../ProjectStats';
import { CompactCardContainer, CompactContent, CompactImageContainer, PlaceholderIcon, CategoryBadgeContainer, CompactContentContainer, CompactHeader, AuthorInfo, VerifiedBadge, FeaturedBadge, MenuButtonContainer, MenuButton, ProjectInfoContainer, ProjectTitle, ProjectDescription, StatsContainer, DateInfo } from './styles';
export var ProjectCardCompact = function(param) {
    var project = param.project, isMenuOpen = param.isMenuOpen, onMenuToggle = param.onMenuToggle, onMenuClose = param.onMenuClose, onViewDetails = param.onViewDetails, onLike = param.onLike, onComment = param.onComment, onDelete = param.onDelete, onReport = param.onReport, onClick = param.onClick, className = param.className, _param_showActions = param.showActions, showActions = _param_showActions === void 0 ? true : _param_showActions, isOwner = param.isOwner, isAuthenticated = param.isAuthenticated, hasMedia = param.hasMedia, allMediaUrls = param.allMediaUrls, filterImageUrls = param.filterImageUrls, filterVideoUrls = param.filterVideoUrls, filterShortFormUrls = param.filterShortFormUrls;
    var compactMenuTriggerRef = useRef(null);
    return /*#__PURE__*/ React.createElement(CompactCardContainer, {
        className: cn("relative", className),
        onClick: onClick || onViewDetails
    }, /*#__PURE__*/ React.createElement(CompactContent, null, /*#__PURE__*/ React.createElement(CompactImageContainer, null, /*#__PURE__*/ React.createElement(PlaceholderIcon, null, /*#__PURE__*/ React.createElement(Compass, {
        className: "h-5 w-5"
    })), hasMedia && /*#__PURE__*/ React.createElement(ContentMediaGrid, {
        images: filterImageUrls(allMediaUrls),
        videos: filterVideoUrls(allMediaUrls),
        shortFormVideos: filterShortFormUrls(allMediaUrls),
        className: "h-full w-full",
        useBuiltInModal: true
    }), /*#__PURE__*/ React.createElement(CategoryBadgeContainer, {
        isCompact: true
    }, /*#__PURE__*/ React.createElement(CategoryBadge, {
        category: project.category
    }))), /*#__PURE__*/ React.createElement(CompactContentContainer, null, /*#__PURE__*/ React.createElement(CompactHeader, null, /*#__PURE__*/ React.createElement(AuthorInfo, null, project.author.name, project.author.verified && /*#__PURE__*/ React.createElement(VerifiedBadge, null, "✓"), project.featured && /*#__PURE__*/ React.createElement(FeaturedBadge, null, "★")), /*#__PURE__*/ React.createElement(MenuButtonContainer, null, /*#__PURE__*/ React.createElement(MenuButton, {
        ref: compactMenuTriggerRef,
        onClick: function(e) {
            e.stopPropagation();
            onMenuToggle();
        },
        "aria-label": "프로젝트 설정",
        isDefault: false
    }, /*#__PURE__*/ React.createElement(MoreHorizontal, {
        className: "h-3.5 w-3.5"
    })), isMenuOpen && /*#__PURE__*/ React.createElement(DropdownMenu, {
        isOpen: isMenuOpen,
        onClose: onMenuClose,
        triggerRef: compactMenuTriggerRef,
        position: "right",
        className: "absolute right-0 mt-1 z-50"
    }, isOwner && onDelete && /*#__PURE__*/ React.createElement(DropdownMenuItem, {
        icon: /*#__PURE__*/ React.createElement(Trash, {
            size: 14
        }),
        onClick: onDelete,
        className: "text-red-600 hover:bg-red-50"
    }, "삭제"), !isOwner && isAuthenticated && onReport && /*#__PURE__*/ React.createElement(DropdownMenuItem, {
        icon: /*#__PURE__*/ React.createElement(Flag, {
            size: 14
        }),
        onClick: onReport,
        className: "text-red-600 hover:bg-red-50"
    }, "신고")))), /*#__PURE__*/ React.createElement(ProjectInfoContainer, null, /*#__PURE__*/ React.createElement(ProjectTitle, {
        $isCompact: true
    }, project.title), /*#__PURE__*/ React.createElement(ProjectDescription, {
        $isCompact: true
    }, project.description)), /*#__PURE__*/ React.createElement(StatsContainer, {
        $isCompact: true
    }, /*#__PURE__*/ React.createElement("div", null, showActions && /*#__PURE__*/ React.createElement(ProjectStats, {
        views: project.views,
        likes: project.likes,
        comments: project.comments,
        onLikeClick: onLike,
        onCommentClick: onComment,
        className: "text-xs scale-75 origin-left transform"
    })), /*#__PURE__*/ React.createElement(DateInfo, {
        $isCompact: true
    }, new Date(project.createdAt).toLocaleDateString())))));
};
export default ProjectCardCompact;
